declare namespace $ {

	export class $shm_hitalama_profile_quick extends $shm_hitalama_quick {
	}
	
}

//# sourceMappingURL=quick.view.tree.d.ts.map